/* MYBOOST V59.3 â€” Variant selector JS (extracted from snippets/myboost-variant-selector.liquid)
   Extracted from the inline <script> IIFE at the bottom of the variant selector liquid.
   Reads JSON data from #mb-i18n and #mb-variants-data which remain inlined in the liquid
   (because they contain Shopify Liquid output).

   Loading requirement: this script MUST execute after #mb-selector, #mb-i18n and
   #mb-variants-data are present in the DOM. The liquid snippet outputs them before
   the script tag, so a normal (deferred) script tag works.

   Behavior: identical to the previous inline IIFE. No subscription/UI changes.
*/
(function(){
'use strict';
const sel = document.getElementById('mb-selector');
if (!sel) return;
const CONFIG = {
  LOCALE: sel.dataset.locale || 'fr',
  // Use server-side market currency hint (set in header.liquid via localization.market.currency.iso_code)
  // This prevents fallback to shop.currency = USD when store default was changed.
  CURRENCY: window.__mbh_market_currency || sel.dataset.currency || 'EUR',
  RATE: parseFloat(sel.dataset.rate) || 1,
  IS_ABONNES: sel.dataset.isAbonnes === 'true',
  IS_IG_ABONNES: sel.dataset.isIgAbonnes === 'true',
  IS_TK_ABONNES: sel.dataset.isTkAbonnes === 'true',
  SELLING_PLANS: { hebdo: 689782325582, mensuel: 689782358350 },
  TARGETED_MULTIPLIER: 1.7,
  COOKIE_NAME: 'mb_user',
  COOKIE_DAYS: 30
};
const INPUT_MODE = CONFIG.IS_IG_ABONNES ? 'ig_search' : CONFIG.IS_TK_ABONNES ? 'tk_search' : CONFIG.IS_ABONNES ? 'username' : 'link';
const HAS_SEARCH = INPUT_MODE === 'ig_search' || INPUT_MODE === 'tk_search';
const VARIANTS = JSON.parse(document.getElementById('mb-variants-data')?.textContent || '[]');
// Sold-out detection: true when every variant is unavailable
const ALL_SOLD_OUT = VARIANTS.length > 0 && VARIANTS.every(v => v.available === false);

// ==================== V59.3 FIX: DYNAMIC OPTION2 DETECTION ====================
// Instead of hardcoding 'Mix' and '🇫🇷', detect actual option2 values from variant data
const _OPT2_ALL = [...new Set(VARIANTS.map(v => v.option2).filter(Boolean))];
let OPT2_MIX = _OPT2_ALL[0] || 'Mix';
let OPT2_TARGETED = _OPT2_ALL[1] || OPT2_MIX;
// Identify which option2 value corresponds to "mix" using common patterns
for (const val of _OPT2_ALL) {
  const lv = (val || '').toLowerCase();
  if (lv === 'mix' || lv === 'mixte' || lv.includes('mix') || lv.includes('\u{1F30D}') || lv.includes('international') || lv.includes('monde') || lv.includes('world')) {
    OPT2_MIX = val;
    break;
  }
}
// Targeted = whichever option2 value is NOT mix
if (_OPT2_ALL.length >= 2) {
  OPT2_TARGETED = _OPT2_ALL.find(v => v !== OPT2_MIX) || _OPT2_ALL[1];
} else {
  OPT2_TARGETED = OPT2_MIX; // single option2 = same price for both
}
// Debug log
console.log('MyBoost option2 mapping:', { all: _OPT2_ALL, mix: OPT2_MIX, targeted: OPT2_TARGETED });
// ==============================================================================

const COUNTRIES = [
  { key: 'french', emoji: '🇫🇷', continent: 'europe', prio: { fr: 1 } },
  { key: 'swiss', emoji: '🇨🇭', continent: 'europe', prio: { fr: 2 } },
  { key: 'belgian', emoji: '🇧🇪', continent: 'europe', prio: { fr: 3 } },
  { key: 'canadian', emoji: '🇨🇦', continent: 'america', prio: { fr: 4, en: 5 } },
  { key: 'luxembourgish', emoji: '🇱🇺', continent: 'europe', prio: { fr: 5 } },
  { key: 'german', emoji: '🇩🇪', continent: 'europe', prio: { de: 1 } },
  { key: 'spanish', emoji: '🇪🇸', continent: 'europe', prio: { es: 1 } },
  { key: 'italian', emoji: '🇮🇹', continent: 'europe', prio: { it: 1 } },
  { key: 'portuguese', emoji: '🇵🇹', continent: 'europe', prio: { pt: 1 } },
  { key: 'british', emoji: '🇬🇧', continent: 'europe', prio: { en: 1 } },
  { key: 'dutch', emoji: '🇳🇱', continent: 'europe', prio: { nl: 1 } },
  { key: 'polish', emoji: '🇵🇱', continent: 'europe', prio: { pl: 1 } },
  { key: 'greek', emoji: '🇬🇷', continent: 'europe', prio: {} },
  { key: 'romanian', emoji: '🇷🇴', continent: 'europe', prio: { ro: 1 } },
  { key: 'hungarian', emoji: '🇭🇺', continent: 'europe', prio: {} },
  { key: 'czech', emoji: '🇨🇿', continent: 'europe', prio: { cs: 1 } },
  { key: 'austrian', emoji: '🇦🇹', continent: 'europe', prio: { de: 2 } },
  { key: 'swedish', emoji: '🇸🇪', continent: 'europe', prio: { sv: 1 } },
  { key: 'norwegian', emoji: '🇳🇴', continent: 'europe', prio: {} },
  { key: 'danish', emoji: '🇩🇰', continent: 'europe', prio: { da: 1 } },
  { key: 'finnish', emoji: '🇫🇮', continent: 'europe', prio: { fi: 1 } },
  { key: 'irish', emoji: '🇮🇪', continent: 'europe', prio: { en: 6 } },
  { key: 'moroccan', emoji: '🇲🇦', continent: 'africa', prio: { ar: 1, fr: 6 } },
  { key: 'algerian', emoji: '🇩🇿', continent: 'africa', prio: { ar: 2, fr: 7 } },
  { key: 'tunisian', emoji: '🇹🇳', continent: 'africa', prio: { ar: 3, fr: 8 } },
  { key: 'egyptian', emoji: '🇪🇬', continent: 'africa', prio: { ar: 4 } },
  { key: 'lebanese', emoji: '🇱🇧', continent: 'asia', prio: { ar: 5 } },
  { key: 'emirati', emoji: '🇦🇪', continent: 'asia', prio: { ar: 6 } },
  { key: 'saudi', emoji: '🇸🇦', continent: 'asia', prio: { ar: 7 } },
  { key: 'turkish', emoji: '🇹🇷', continent: 'asia', prio: { tr: 1 } },
  { key: 'israeli', emoji: '🇮🇱', continent: 'asia', prio: {} },
  { key: 'senegalese', emoji: '🇸🇳', continent: 'africa', prio: { fr: 9 } },
  { key: 'ivorian', emoji: '🇨🇮', continent: 'africa', prio: { fr: 10 } },
  { key: 'cameroonian', emoji: '🇨🇲', continent: 'africa', prio: { fr: 11 } },
  { key: 'malian', emoji: '🇲🇱', continent: 'africa', prio: { fr: 12 } },
  { key: 'nigerian', emoji: '🇳🇬', continent: 'africa', prio: { en: 7 } },
  { key: 'southafrican', emoji: '🇿🇦', continent: 'africa', prio: { en: 8 } },
  { key: 'american', emoji: '🇺🇸', continent: 'america', prio: { en: 2 } },
  { key: 'brazilian', emoji: '🇧🇷', continent: 'america', prio: { pt: 2 } },
  { key: 'mexican', emoji: '🇲🇽', continent: 'america', prio: { es: 2 } },
  { key: 'argentine', emoji: '🇦🇷', continent: 'america', prio: { es: 3 } },
  { key: 'colombian', emoji: '🇨🇴', continent: 'america', prio: { es: 4 } },
  { key: 'chilean', emoji: '🇨🇱', continent: 'america', prio: { es: 5 } },
  { key: 'peruvian', emoji: '🇵🇪', continent: 'america', prio: { es: 6 } },
  { key: 'japanese', emoji: '🇯🇵', continent: 'asia', prio: { ja: 1 } },
  { key: 'korean', emoji: '🇰🇷', continent: 'asia', prio: { ko: 1 } },
  { key: 'chinese', emoji: '🇨🇳', continent: 'asia', prio: { zh: 1 } },
  { key: 'indian', emoji: '🇮🇳', continent: 'asia', prio: { hi: 1 } },
  { key: 'indonesian', emoji: '🇮🇩', continent: 'asia', prio: { id: 1 } },
  { key: 'thai', emoji: '🇹🇭', continent: 'asia', prio: { th: 1 } },
  { key: 'vietnamese', emoji: '🇻🇳', continent: 'asia', prio: { vi: 1 } },
  { key: 'filipino', emoji: '🇵🇭', continent: 'asia', prio: { tl: 1 } },
  { key: 'malaysian', emoji: '🇲🇾', continent: 'asia', prio: { ms: 1 } },
  { key: 'singaporean', emoji: '🇸🇬', continent: 'asia', prio: { en: 9, zh: 2 } },
  { key: 'australian', emoji: '🇦🇺', continent: 'oceania', prio: { en: 3 } },
  { key: 'newzealander', emoji: '🇳🇿', continent: 'oceania', prio: { en: 4 } }
];
const I18N = JSON.parse(document.getElementById('mb-i18n')?.textContent || '{}');
const t = key => I18N[key] || key;
// ==================== STATE ====================
let state = { option1: null, type: 'mix', country: { key: 'french', emoji: '🇫🇷' }, delivery: 'immediate', promo: null, promoPercent: 0, user: null }; /* COMPLIANCE 2026-07-24: one-time purchase is the default; the subscription must NOT be pre-selected (payment-reviewer requirement). */
// ==================== V59.3: POPUP USER STATE ====================
let popupUser = null; // user selected inside popup
let pendingBuyNow = false; // true = popup was triggered by Buy Now
// ==================== UTILS ====================
const $ = id => document.getElementById(id);
const $$ = s => document.querySelectorAll(s);
function setCookie(n, v, d) { const e = new Date(); e.setTime(e.getTime() + d * 86400000); document.cookie = n + '=' + encodeURIComponent(v) + ';expires=' + e.toUTCString() + ';path=/'; }
function getCookie(n) { const m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m.pop()) : ''; }
function formatMoney(cents) {
  // Base amount in the store's native currency (EUR — prices stored in EUR cents)
  var amount = (cents * CONFIG.RATE) / 100;
  // If displaying in a non-EUR currency (e.g. USD on International market),
  // the RATE is the EUR→target conversion. Round UP to nearest whole unit.
  if (CONFIG.RATE !== 1 && CONFIG.CURRENCY !== 'EUR') {
    amount = Math.ceil(amount);
  }
  return new Intl.NumberFormat(CONFIG.LOCALE || 'en', { style: 'currency', currency: CONFIG.CURRENCY }).format(amount);
}
function formatFollowers(n) { if (n >= 1000000) return (n / 1000000).toFixed(1).replace('.0', '') + 'M'; if (n >= 1000) return (n / 1000).toFixed(1).replace('.0', '') + 'K'; return n.toString(); }
function getPromoMin(btn) {
  try { const mins = JSON.parse(btn.dataset.mins || '{}'); if (mins[CONFIG.CURRENCY] !== undefined) return mins[CONFIG.CURRENCY]; } catch(e) {}
  return parseFloat(btn.dataset.min) || 0;
}
// ==================== VARIANTS ====================
function findVariant(opt1, type) {
  // V59.3 FIX: Use dynamically detected option2 values instead of hardcoded strings
  const opt2 = type === 'mix' ? OPT2_MIX : OPT2_TARGETED;
  for (const v of VARIANTS) if (v.option1 === opt1 && v.option2 === opt2) return v;
  for (const v of VARIANTS) if (v.option1 === opt1) return v;
  return VARIANTS[0];
}
function getPrice(opt1, type) { const v = findVariant(opt1, type); return v ? v.price : 0; }
function getCurrentPrice() { let p = getPrice(state.option1, state.type); if (state.promo && state.promoPercent > 0) p = Math.round(p * (1 - state.promoPercent / 100)); return p; }
// ==================== UI ====================
function updatePrices() {
  $$('.mb-qty-pill').forEach(pill => {
    const _cents = getPrice(pill.dataset.value, state.type);
    const _p = pill.querySelector('.mb-qty-price'); if (_p) _p.textContent = formatMoney(_cents);
    const _tot = extractQty(pill.dataset.value), _loc = CONFIG.LOCALE || 'fr';
    const _perf = pill.querySelector('.mb-qty-perf');
    if (_perf && _tot > 0) { const _ppu = ((_cents * CONFIG.RATE) / 100) / _tot; _perf.textContent = '≈ ' + new Intl.NumberFormat(_loc, { style: 'currency', currency: CONFIG.CURRENCY, minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(_ppu) + ' ' + (t('unit_price_suffix') || ''); }
    const _res = pill.querySelector('.mb-qty-result');
    if (_res && _tot > 0) { const _af = window.__mbAF || 0; _res.innerHTML = _af > 0 ? ('👥 ' + _af.toLocaleString(_loc) + ' → <b>' + (_af + _tot).toLocaleString(_loc) + '</b>') : ('👥 <b>' + _tot.toLocaleString(_loc) + '</b>'); }
  });
  const pm = $('mb-price-mix'), pt = $('mb-price-targeted');
  if (pm && state.option1) pm.textContent = formatMoney(getPrice(state.option1, 'mix'));
  if (pt && state.option1) pt.textContent = formatMoney(getPrice(state.option1, 'targeted'));
  const cur = $('mb-buy-current'), old = $('mb-buy-old');
  const price = getCurrentPrice(), base = getPrice(state.option1, state.type);
  if (cur) cur.textContent = formatMoney(price);
  if (old) { if (state.promo) { old.textContent = formatMoney(base); old.style.display = 'inline'; } else old.style.display = 'none'; }
  // V63: under 20€ -> grey the buy button + show "Panier minimum 20€" and a fill bar progressing toward 20€, ON the button
  (function applyBuyMin() {
    const buyBtn = $('mb-buy-now');
    if (!buyBtn) return;
    if (!document.getElementById('mb-min-btn-css')) {
      const stMin = document.createElement('style'); stMin.id = 'mb-min-btn-css';
      stMin.textContent =
        '#mb-buy-now.mb-min-block{position:relative;overflow:hidden;cursor:not-allowed;background:#e6e6ee!important;border-color:#e6e6ee!important;box-shadow:none!important}' +
        '#mb-buy-now.mb-min-block>*:not(.mb-min-bar):not(.mb-min-overlay){visibility:hidden!important}' +
        '#mb-buy-now .mb-min-bar,#mb-buy-now .mb-min-overlay{display:none}' +
        '#mb-buy-now.mb-min-block .mb-min-bar{display:block;position:absolute;left:0;top:0;bottom:0;width:0;background:linear-gradient(90deg,#FF9D86,#FF6EF8,#3DBAFF);transition:width .5s cubic-bezier(.4,0,.2,1);z-index:1}' +
        '#mb-buy-now.mb-min-block .mb-min-overlay{display:flex;flex-direction:column;gap:2px;position:absolute;inset:0;z-index:2;align-items:center;justify-content:center;padding:0 12px;text-align:center;line-height:1.15;color:#fff;text-shadow:0 1px 3px rgba(0,0,0,.3)}' +
        '#mb-buy-now.mb-min-block .mb-min-overlay .mb-min-title{font-weight:800;font-size:15px;letter-spacing:.2px}' +
        '#mb-buy-now.mb-min-block .mb-min-overlay .mb-min-amt{font-weight:700;font-size:12px;opacity:.95}';
      document.head.appendChild(stMin);
    }
    let bar = buyBtn.querySelector('.mb-min-bar');
    if (!bar) { bar = document.createElement('span'); bar.className = 'mb-min-bar'; buyBtn.insertBefore(bar, buyBtn.firstChild); }
    let overlay = buyBtn.querySelector('.mb-min-overlay');
    if (!overlay) {
      overlay = document.createElement('span'); overlay.className = 'mb-min-overlay';
      overlay.innerHTML = '<span class="mb-min-title"></span><span class="mb-min-amt"></span>';
      buyBtn.appendChild(overlay);
    }
    const underMin = base > 0 && base < 2000;
    buyBtn.classList.toggle('mb-min-block', underMin);
    if (underMin) {
      buyBtn.setAttribute('disabled', 'disabled');
      const pct = Math.max(6, Math.min(100, Math.round(base * 100 / 2000)));
      bar.style.width = pct + '%';
      overlay.querySelector('.mb-min-title').textContent = 'Panier minimum ' + formatMoney(2000);
      overlay.querySelector('.mb-min-amt').textContent = formatMoney(base) + ' / ' + formatMoney(2000);
    } else {
      buyBtn.removeAttribute('disabled');
    }
  })();
  const unit = $('mb-unit-price');
  if (unit && state.option1) {
    const qty = extractQty(state.option1);
    if (qty > 0) {
      const ppu = ((price * CONFIG.RATE) / 100) / qty;
      const ppuFormatted = new Intl.NumberFormat(CONFIG.LOCALE || 'fr', { style: 'currency', currency: CONFIG.CURRENCY, minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(ppu);
      unit.innerHTML = t('unit_price_prefix') + ' <span class="gradient">' + ppuFormatted + '</span> ' + t('unit_price_suffix');
      unit.style.display = 'block';
    }
  }
  const basePriceLocal = (base * CONFIG.RATE) / 100;
  $$('.mb-promo-btn').forEach(btn => {
    const min = getPromoMin(btn);
    if (basePriceLocal < min) { btn.classList.add('disabled'); if (btn.classList.contains('selected')) { btn.classList.remove('selected'); state.promo = null; state.promoPercent = 0; } }
    else { btn.classList.remove('disabled'); }
  });
}
function extractQty(s) {
  if (!s) return 0;
  const m = s.toUpperCase().match(/(\d+(?:[.,]\d+)?)\s*K?/g);
  if (!m) return 0;
  const values = CONFIG.IS_ABONNES ? [m[0]] : m;
  return values.reduce((total, value) => {
    let quantity = parseFloat(value.replace(',', '.'));
    if (value.includes('K')) quantity *= 1000;
    return total + quantity;
  }, 0);
}
// ==================== COUNTRIES ====================
function buildCountryList() {
  const list = $('mb-country-list'); if (!list) return;
  const locale = CONFIG.LOCALE;
  const sorted = COUNTRIES.map(c => ({ ...c, name: t(c.key), priority: c.prio[locale] || 99 })).sort((a, b) => a.priority - b.priority);
  const groups = {}; sorted.forEach(c => { if (!groups[c.continent]) groups[c.continent] = []; groups[c.continent].push(c); });
  const order = locale === 'fr' ? ['europe', 'africa', 'america', 'asia', 'oceania'] : locale === 'es' ? ['america', 'europe', 'africa', 'asia', 'oceania'] : locale === 'de' ? ['europe', 'asia', 'america', 'africa', 'oceania'] : ['america', 'europe', 'asia', 'africa', 'oceania'];
  let html = '';
  order.forEach(cont => { if (!groups[cont]) return; html += '<div class="mb-country-group-title">' + t('continent_' + cont) + '</div>'; groups[cont].forEach(c => { html += '<div class="mb-country-item" data-key="' + c.key + '" data-emoji="' + c.emoji + '"><span class="mb-country-item-flag">' + c.emoji + '</span><span class="mb-country-item-name">' + c.name + '</span><svg class="mb-country-item-check" viewBox="0 0 24 24" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg></div>'; }); });
  list.innerHTML = html;
  selectCountry('french', '🇫🇷');
  list.querySelectorAll('.mb-country-item').forEach(item => { item.onclick = () => selectCountry(item.dataset.key, item.dataset.emoji); });
}
function selectCountry(key, emoji) {
  state.country = { key, emoji };
  $$('.mb-country-item').forEach(i => i.classList.toggle('selected', i.dataset.key === key));
  const flag = $('mb-country-flag'), name = $('mb-country-name');
  if (flag) flag.textContent = emoji; if (name) name.textContent = t(key);
  $('mb-country-selected')?.classList.remove('open'); $('mb-country-list-wrapper')?.classList.remove('open');
}
function filterCountries(q) { q = q.toLowerCase(); $$('.mb-country-item').forEach(item => { item.classList.toggle('hidden', q && !t(item.dataset.key).toLowerCase().includes(q)); }); }
// ==================== SEARCH (Instagram + TikTok) ====================
let searchCtrl = null, searchTimeout = null;
async function searchIG(q) {
  if (!q || q.length < 1) return [];
  if (searchCtrl) searchCtrl.abort(); searchCtrl = new AbortController();
  try {
    const res = await fetch('https://instagram-proxy-indol.vercel.app/api?keyword=' + encodeURIComponent(q), { signal: searchCtrl.signal });
    const data = await res.json();
    return data.data?.items?.slice(0, 8) || data.data?.filter(i => i.user).map(i => i.user).slice(0, 8) || [];
  } catch { return []; }
}
async function searchTK(q) {
  if (!q || q.length < 1) return [];
  if (searchCtrl) searchCtrl.abort(); searchCtrl = new AbortController();
  try {
    const res = await fetch('https://instagram-proxy-indol.vercel.app/api/tiktok?keyword=' + encodeURIComponent(q), { signal: searchCtrl.signal });
    const data = await res.json();
    return (data.user_list || []).slice(0, 8).map(item => {
      const avatarList = item.user_info?.avatar_168x168?.url_list || item.user_info?.avatar_thumb?.url_list || [];
      const jpegUrl = avatarList.find(u => u.includes('.jpeg')) || avatarList[2] || avatarList[0] || '';
      return { username: item.user_info?.unique_id || '', full_name: item.user_info?.nickname || '', profile_pic_url: jpegUrl, is_verified: item.user_info?.custom_verify === 'Verified account', follower_count: item.user_info?.follower_count || 0 };
    });
  } catch { return []; }
}
async function doSearch(q) {
  if (INPUT_MODE === 'ig_search') return searchIG(q);
  if (INPUT_MODE === 'tk_search') return searchTK(q);
  return [];
}
// ==================== SEARCH UI (shared for main + popup) ====================
function renderSearchResults(users, dropdownEl, onSelect) {
  if (!dropdownEl) return;
  if (!users?.length) { dropdownEl.innerHTML = '<div class="mb-search-empty">' + t('search_empty') + '</div>'; dropdownEl.classList.add('visible'); return; }
  const igProxy = 'https://instagram-proxy-indol.vercel.app/api?url=';
  let html = '';
  users.forEach(u => {
    const pp = u.profile_pic_url ? (INPUT_MODE === 'ig_search' ? igProxy + encodeURIComponent(u.profile_pic_url) : u.profile_pic_url) : '';
    html += '<div class="mb-search-result" data-username="' + (u.username || '') + '" data-pp="' + pp + '" data-followers="' + (u.follower_count || 0) + '"><img class="mb-search-result-pp" src="' + pp + '" onerror="this.style.background=\'#eee\'"><div class="mb-search-result-info"><div class="mb-search-result-top"><span class="mb-search-result-username">' + u.username + '</span>';
    if (u.is_verified) html += '<svg class="mb-search-result-verified" viewBox="0 0 24 24" fill="#3897f0"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>';
    html += '</div><div class="mb-search-result-name">' + (u.full_name || '') + '</div>';
    if (INPUT_MODE === 'tk_search' && u.follower_count) html += '<div class="mb-search-result-followers">' + formatFollowers(u.follower_count) + ' followers</div>';
    html += '</div></div>';
  });
  dropdownEl.innerHTML = html; dropdownEl.classList.add('visible');
  dropdownEl.querySelectorAll('.mb-search-result').forEach(r => { r.onclick = () => onSelect({ username: r.dataset.username, pp: r.dataset.pp, followers: parseInt(r.dataset.followers || '0', 10) }); });
}
function showSearchLoadingIn(dropdownEl) {
  if (!dropdownEl) return;
  dropdownEl.innerHTML = '<div class="mb-search-loading"><div class="mb-search-progress"><div class="mb-search-progress-bar"></div></div>' + t('search_loading') + '</div>';
  dropdownEl.classList.add('visible');
}
// ==================== MAIN FORM: select/clear user ====================
function selectUser(u) {
  state.user = u;
  const input = $('mb-username'), pp = $('mb-selected-pp'), user = $('mb-selected-user'), clear = $('mb-clear-btn');
  if (input) { input.value = u.username; input.classList.add('has-selection'); }
  if (pp) pp.src = u.pp; if (user) user.classList.add('visible'); if (clear) clear.classList.add('visible');
  $('mb-search-dropdown')?.classList.remove('visible');
  setCookie(CONFIG.COOKIE_NAME + '_' + INPUT_MODE, JSON.stringify(u), CONFIG.COOKIE_DAYS);
  window.__mbAF = u.followers || 0; if (typeof updatePrices === 'function') updatePrices();
}
function clearUser() {
  state.user = null;
  const input = $('mb-username'), user = $('mb-selected-user'), clear = $('mb-clear-btn');
  if (input) { input.value = ''; input.classList.remove('has-selection'); input.focus(); }
  if (user) user.classList.remove('visible'); if (clear) clear.classList.remove('visible');
  window.__mbAF = 0; if (typeof updatePrices === 'function') updatePrices();
}
// ==================== V59.3: POPUP USERNAME LOGIC ====================
function openUserPopup() {
  const overlay = $('mb-userpopup');
  if (!overlay) return;
  popupUser = null;
  // Reset popup state
  const input = $('mb-popup-username');
  const selUser = $('mb-popup-selected-user');
  const clearBtn = $('mb-popup-clear-btn');
  const dd = $('mb-popup-search-dropdown');
  const buyBtn = $('mb-userpopup-confirm-buy');
  const cartBtn = $('mb-userpopup-confirm-cart');
  if (input) { input.value = ''; input.classList.remove('has-selection'); }
  if (selUser) selUser.classList.remove('visible');
  if (clearBtn) clearBtn.classList.remove('visible');
  if (dd) dd.classList.remove('visible');
  // Show correct button
  if (buyBtn) { buyBtn.disabled = true; buyBtn.style.display = pendingBuyNow ? 'flex' : 'none'; }
  if (cartBtn) { cartBtn.disabled = true; cartBtn.style.display = pendingBuyNow ? 'none' : 'flex'; }
  // Show overlay
  if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
  const scrollY = window.scrollY;
  document.body.dataset.userpopupScrollY = scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + scrollY + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.overflow = 'hidden';
  overlay.classList.add('show');
  setTimeout(() => { if (input) input.focus(); }, 350);
}
function closeUserPopup() {
  const overlay = $('mb-userpopup');
  if (!overlay) return;
  overlay.classList.remove('show');
  const scrollY = document.body.dataset.userpopupScrollY || 0;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.overflow = '';
  window.scrollTo(0, parseInt(scrollY));
}
function popupSelectUser(u) {
  popupUser = u;
  const input = $('mb-popup-username');
  const pp = $('mb-popup-selected-pp');
  const selUser = $('mb-popup-selected-user');
  const clearBtn = $('mb-popup-clear-btn');
  const dd = $('mb-popup-search-dropdown');
  if (input) { input.value = u.username; input.classList.add('has-selection'); }
  if (pp) pp.src = u.pp;
  if (selUser) selUser.classList.add('visible');
  if (clearBtn) clearBtn.classList.add('visible');
  if (dd) dd.classList.remove('visible');
  const buyBtn = $('mb-userpopup-confirm-buy');
  const cartBtn = $('mb-userpopup-confirm-cart');
  if (buyBtn) buyBtn.disabled = false;
  if (cartBtn) cartBtn.disabled = false;
}
function popupClearUser() {
  popupUser = null;
  const input = $('mb-popup-username');
  const selUser = $('mb-popup-selected-user');
  const clearBtn = $('mb-popup-clear-btn');
  if (input) { input.value = ''; input.classList.remove('has-selection'); input.focus(); }
  if (selUser) selUser.classList.remove('visible');
  if (clearBtn) clearBtn.classList.remove('visible');
  const buyBtn = $('mb-userpopup-confirm-buy');
  const cartBtn = $('mb-userpopup-confirm-cart');
  if (buyBtn) buyBtn.disabled = true;
  if (cartBtn) cartBtn.disabled = true;
}
// ==================== CART ====================
async function addToCart(buyNow, overrideUser) {
  const v = findVariant(state.option1, state.type); if (!v) return;
  // Determine username: overrideUser (from popup) takes priority
  const userToUse = overrideUser || state.user;
  const mainInput = $('mb-username');
  const inputValue = overrideUser ? overrideUser.username : (mainInput?.value.trim() || '');

  // V59.3: If search mode + no user selected => show popup
  if (HAS_SEARCH && !inputValue) {
    pendingBuyNow = buyNow;
    openUserPopup();
    return;
  }

  const data = { id: v.id, quantity: 1, properties: {} };
  if (INPUT_MODE === 'ig_search') { const u = inputValue.replace('@', ''); if (u) data.properties['Instagram :'] = u; }
  else if (INPUT_MODE === 'tk_search') { const u = inputValue.replace('@', ''); if (u) data.properties['TikTok :'] = u; }
  else if (INPUT_MODE === 'username') { const u = inputValue.replace('@', ''); if (u) data.properties['Compte :'] = u; }
  else { if (inputValue) data.properties['Lien :'] = inputValue; }
  /* V60: 3-way selling plan mapping */
  if (state.delivery === 'monthly') data.selling_plan = CONFIG.SELLING_PLANS.mensuel;
  else if (state.delivery === 'weekly' || state.delivery === 'progressive') data.selling_plan = CONFIG.SELLING_PLANS.hebdo;
  /* immediate = one-shot, no selling_plan */
  const btn = buyNow ? (overrideUser ? $('mb-userpopup-confirm-buy') : $('mb-buy-now')) : (overrideUser ? $('mb-userpopup-confirm-cart') : $('mb-add-to-cart'));
  btn?.classList.add('loading');
  try {
    if (buyNow) {
      const checkoutPopup = $('mb-checkout-popup');
      if (checkoutPopup) {
        // Close user popup first if open
        closeUserPopup();
        await new Promise(r => setTimeout(r, 100));
        if (checkoutPopup.parentElement !== document.body) document.body.appendChild(checkoutPopup);
        checkoutPopup.style.height = window.innerHeight + 'px';
        const scrollY = window.scrollY; document.body.dataset.checkoutScrollY = scrollY;
        document.body.style.position = 'fixed'; document.body.style.top = '-' + scrollY + 'px'; document.body.style.left = '0'; document.body.style.right = '0'; document.body.style.overflow = 'hidden';
        document.body.classList.add('mb-checkout-locked'); checkoutPopup.classList.add('visible');
        setTimeout(() => { const textEl = $('mb-checkout-popup-text'); if (textEl) textEl.innerHTML = t('checkout_redirect') + '<br><span style="font-size:14px;font-weight:400;color:#666">' + t('checkout_redirect_sub') + '</span><br><small class="mb-wait-text" style="opacity:0.7">' + t('checkout_wait') + '<span class="mb-dots"></span></small>'; }, 2000);
      }
      await fetch('/cart/clear.js', { method: 'POST' });
    }
    const addResp = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
    if (!addResp.ok) throw new Error('cart-add-failed-' + addResp.status);
    // Also sync the main form user if came from popup
    if (overrideUser && !state.user) {
      selectUser(overrideUser);
    }
    const drawer = document.getElementById('MinimogCartDrawer');
    if (drawer?.onCartDrawerUpdate) await drawer.onCartDrawerUpdate();
    // ===== MINIMUM CART CHECK (20€) =====
    if (buyNow) {
      const cartData = await fetch('/cart.js').then(r => r.json());
      const totalCents = cartData.total_price;
      const cartCurrency = cartData.currency || CONFIG.CURRENCY;
      const rate = (function(){ try { return parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch(e) { return 1; } })();
      const minCents = Math.round(2000 * rate); // 20€ in local currency cents
      if (totalCents < minCents) {
        // Under minimum — dismiss checkout popup, show toast, open cart drawer
        const checkoutPopup = $('mb-checkout-popup');
        if (checkoutPopup && checkoutPopup.classList.contains('visible')) {
          checkoutPopup.classList.remove('visible');
          document.body.classList.remove('mb-checkout-locked');
          const scrollY = parseInt(document.body.dataset.checkoutScrollY || 0);
          document.body.style.position = ''; document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = ''; document.body.style.overflow = '';
          window.scrollTo(0, scrollY);
        }
        // Show "added, need X more" toast
        const remainingFmt = new Intl.NumberFormat(CONFIG.LOCALE || 'fr', { style: 'currency', currency: cartCurrency, maximumFractionDigits: 0 }).format((minCents - totalCents) / 100);
        (function showMinToast(rem) {
          var ex = document.getElementById('mb-min-toast'); if (ex) ex.remove();
          var el = document.createElement('div');
          el.id = 'mb-min-toast';
          el.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:99999;background:#1a1a1a;color:#fff;padding:13px 20px;border-radius:14px;font-size:14px;font-weight:600;box-shadow:0 8px 30px rgba(0,0,0,0.3);display:flex;align-items:center;gap:10px;max-width:92vw;white-space:nowrap;animation:mbTstIn 0.3s ease';
          el.innerHTML = '<span style="font-size:17px">✅</span><span>Produit ajouté !&nbsp;</span><span style="font-weight:400;opacity:0.85">Il vous manque <strong>' + rem + '</strong> pour commander</span>';
          if (!document.getElementById('mb-tst-css')) { var s = document.createElement('style'); s.id = 'mb-tst-css'; s.textContent = '@keyframes mbTstIn{from{opacity:0;transform:translateX(-50%) translateY(-12px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}'; document.head.appendChild(s); }
          document.body.appendChild(el);
          setTimeout(function(){ el.style.transition='opacity 0.3s'; el.style.opacity='0'; setTimeout(function(){ if(el.parentNode) el.remove(); },300); }, 3500);
        })(remainingFmt);
        // Update min cart banner in drawer, then open it
        if (typeof window.__mbpCheckMinCart === 'function') window.__mbpCheckMinCart();
        if (overrideUser) closeUserPopup();
        if (drawer && drawer.open) drawer.open();
      } else {
        // Above minimum — proceed to checkout via drawer button (triggers Tagada flow)
        const checkoutBtn = document.querySelector('#MinimogCartDrawer .mb-checkout');
        if (checkoutBtn) checkoutBtn.click(); else window.location.href = '/checkout';
      }
    } else {
      if (overrideUser) closeUserPopup();
      if (drawer && drawer.open) drawer.open();
    }
    // ===== END MINIMUM CART CHECK =====
  } catch (err) {
    // V63: restore the UI if the buy flow failed (e.g. add-to-cart error) instead of leaving the page locked
    const cp = $('mb-checkout-popup');
    if (cp) cp.classList.remove('visible');
    document.body.classList.remove('mb-checkout-locked');
    const sy = parseInt(document.body.dataset.checkoutScrollY || 0);
    document.body.style.position = ''; document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = ''; document.body.style.overflow = '';
    if (sy) window.scrollTo(0, sy);
    alert('Une erreur est survenue, réessaie.');
  }
  btn?.classList.remove('loading');
}
function applyTranslations() {
  $$('[data-i18n]').forEach(el => { el.innerHTML = t(el.dataset.i18n); });
  $$('[data-placeholder-i18n]').forEach(el => { el.placeholder = t(el.dataset.placeholderI18n); });
}
// ==================== EVENTS ====================
function bindEvents() {
  // Quantity pills
  $$('.mb-qty-pill').forEach(pill => { pill.onclick = () => { $$('.mb-qty-pill').forEach(p => p.classList.remove('selected')); pill.classList.add('selected'); state.option1 = pill.dataset.value; updatePrices(); }; });
  $('mb-more-link')?.addEventListener('click', function() { this.classList.toggle('open'); $('mb-more-panel')?.classList.toggle('open'); });
  // Nationality
  $('mb-nat-mix')?.addEventListener('click', function() { $$('.mb-nat-type').forEach(t => t.classList.remove('selected')); this.classList.add('selected'); state.type = 'mix'; $('mb-country-dropdown')?.classList.remove('open'); updatePrices(); });
  $('mb-country-selected')?.addEventListener('click', function() { this.classList.toggle('open'); $('mb-country-list-wrapper')?.classList.toggle('open'); });
  $('mb-country-search')?.addEventListener('input', function() { filterCountries(this.value); });
  document.addEventListener('click', e => { const dd = $('mb-country-dropdown'), sel = $('mb-country-selected'); if (dd && sel && !dd.contains(e.target)) { sel.classList.remove('open'); $('mb-country-list-wrapper')?.classList.remove('open'); } });
  // Delivery (V61: 2 main cards + sub-toggle for frequency inside Progressif)
  function v61SelectCard(cardId, deliveryKey) {
    $$('.mb-delivery-card').forEach(c => c.classList.remove('selected'));
    $(cardId)?.classList.add('selected');
    state.delivery = deliveryKey;
    updateSubSummary();
  }
  $('mb-card-progressif')?.addEventListener('click', function(e) {
    // Don't reselect if click was inside the freq-toggle buttons
    if (e.target.closest('.mb-freq-btn')) return;
    // Activate progressif card with current freq selection (default to monthly)
    const currentFreq = $('mb-freq-monthly')?.classList.contains('selected') ? 'monthly'
                      : $('mb-freq-weekly')?.classList.contains('selected') ? 'weekly'
                      : 'monthly';
    v61SelectCard('mb-card-progressif', currentFreq);
  });
  $('mb-card-immediate')?.addEventListener('click', () => v61SelectCard('mb-card-immediate', 'immediate'));

  // Sub-toggle hebdo/mensuel
  function updateProgressifSubtitle(freq) {
    const sub = $('mb-delivery-progressive-subtitle');
    if (!sub) return;
    sub.textContent = t('delivery_progressive_explain_' + freq);
  }
  $('mb-freq-weekly')?.addEventListener('click', function(e) {
    e.stopPropagation();
    $$('.mb-freq-btn').forEach(b => b.classList.remove('selected'));
    this.classList.add('selected');
    // Activate progressif card too
    $$('.mb-delivery-card').forEach(c => c.classList.remove('selected'));
    $('mb-card-progressif')?.classList.add('selected');
    state.delivery = 'weekly';
    updateProgressifSubtitle('weekly');
    updateSubSummary();
  });
  $('mb-freq-monthly')?.addEventListener('click', function(e) {
    e.stopPropagation();
    $$('.mb-freq-btn').forEach(b => b.classList.remove('selected'));
    this.classList.add('selected');
    $$('.mb-delivery-card').forEach(c => c.classList.remove('selected'));
    $('mb-card-progressif')?.classList.add('selected');
    state.delivery = 'monthly';
    updateProgressifSubtitle('monthly');
    updateSubSummary();
  });

  /* V60 backward compat (in case old IDs still rendered) */
  $('mb-card-monthly')?.addEventListener('click', () => v61SelectCard('mb-card-monthly', 'monthly'));
  $('mb-card-weekly')?.addEventListener('click', () => v61SelectCard('mb-card-weekly', 'weekly'));
  $('mb-card-progressive')?.addEventListener('click', () => v61SelectCard('mb-card-progressive', 'weekly'));

  function updateSubSummary() {
    /* V64 FIX notice: le disclaimer "achat récurrent ou différé" ne doit s'afficher qu'en mode
       récurrent. Le notice n'existe que dans la copie Shoplift B (#mb-selector-b), dont l'id
       "mb-card-immediate" est dupliqué — donc le `state.delivery` global de l'asset (qui pilote A)
       est faux pour B. On dérive la visibilité de CHAQUE notice de la card sélectionnée dans son
       propre conteneur .mb-selector (piloté par le DOM, indépendant des IDs dupliqués). */
    document.querySelectorAll('.mb-subscription-notice').forEach(function(n){
      var w = n.closest('.mb-selector');
      var c = w ? w.querySelector('.mb-delivery-card.selected') : null;
      var imm = !!c && (c.id === 'mb-card-immediate' || /\b(?:immediate|onetime)\b/.test(c.className) || c.getAttribute('data-type') === 'onetime');
      n.style.display = imm ? 'none' : '';
    });
    const box = $('mb-sub-summary');
    if (!box) return;
    const priceEl = $('mb-buy-current');
    const priceStr = priceEl?.textContent?.trim() || '--';
    const icon = $('mb-sub-summary-icon');
    const title = $('mb-sub-summary-title');
    const text = $('mb-sub-summary-text');
    const cancel = $('mb-sub-summary-cancel');
    /* V60: render via i18n keys with {price} placeholder */
    function renderText(template) {
      return (template || '').replace('__price__', '<strong class="mb-sub-price">' + priceStr + '</strong>');
    }
    if (state.delivery === 'monthly') {
      box.dataset.state = 'monthly';
      if (icon) icon.textContent = '📅';
      if (title) title.textContent = t('sub_summary_monthly_title');
      if (text) text.innerHTML = renderText(t('sub_summary_monthly_text'));
      if (cancel) cancel.textContent = t('sub_summary_cancel');
    } else if (state.delivery === 'weekly') {
      box.dataset.state = 'weekly';
      if (icon) icon.textContent = '⚡';
      if (title) title.textContent = t('sub_summary_weekly_title');
      if (text) text.innerHTML = renderText(t('sub_summary_weekly_text'));
      if (cancel) cancel.textContent = t('sub_summary_cancel');
    } else if (state.delivery === 'immediate') {
      box.dataset.state = 'onetime';
      if (icon) icon.textContent = '✅';
      if (title) title.textContent = t('sub_summary_onetime_title');
      if (text) text.innerHTML = renderText(t('sub_summary_onetime_text'));
      if (cancel) cancel.textContent = t('sub_summary_onetime_delivery');
    }
  }
  /* Expose globally so updatePrices() can call it after price changes */
  window.__v60_updateSubSummary = updateSubSummary;

  function closePopup(resetToProgressive) {
    /* V60: popup not used, kept for legacy popup-confirm/cancel buttons safety */
    const popup = $('mb-popup');
    if (popup) { popup.classList.remove('show'); const scrollY = document.body.dataset.popupScrollY || 0; document.body.style.position = ''; document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = ''; document.body.style.overflow = ''; document.body.classList.remove('mb-popup-locked'); window.scrollTo(0, parseInt(scrollY)); }
    if (resetToProgressive) { v60SelectDelivery('mb-card-monthly', 'monthly'); }
  }
  $('mb-popup-close')?.addEventListener('click', () => closePopup(true));
  $('mb-popup-cancel')?.addEventListener('click', () => closePopup(false));
  $('mb-popup-confirm')?.addEventListener('click', () => { closePopup(false); $$('.mb-delivery-card').forEach(c => c.classList.remove('selected')); $('mb-card-immediate')?.classList.add('selected'); state.delivery = 'immediate'; const notice = document.querySelector('.mb-subscription-notice'); if (notice) notice.style.display = 'none'; });
  $('mb-popup')?.addEventListener('click', function(e) { if (e.target === this) closePopup(true); });
  // Promos
  $$('.mb-promo-btn').forEach(btn => {
    btn.onclick = function() {
      if (this.classList.contains('disabled')) return;
      if (this.classList.contains('selected')) { this.classList.remove('selected'); state.promo = null; state.promoPercent = 0; }
      else { $$('.mb-promo-btn').forEach(b => b.classList.remove('selected')); this.classList.add('selected'); state.promo = this.dataset.code; state.promoPercent = parseInt(this.dataset.percent) || 0; }
      updatePrices();
    };
  });
  // ==================== MAIN FORM: Search input ====================
  const usernameInput = $('mb-username');
  if (usernameInput && HAS_SEARCH) {
    let mainSearchTimeout = null;
    usernameInput.addEventListener('input', function() {
      const q = this.value.trim().replace('@', '');
      if (state.user && q !== state.user.username) clearUser();
      if (mainSearchTimeout) clearTimeout(mainSearchTimeout);
      if (q.length < 1) { $('mb-search-dropdown')?.classList.remove('visible'); return; }
      showSearchLoadingIn($('mb-search-dropdown'));
      mainSearchTimeout = setTimeout(async () => { const results = await doSearch(q); if (usernameInput.value.trim().replace('@', '') === q) renderSearchResults(results, $('mb-search-dropdown'), selectUser); }, 150);
    });
    usernameInput.addEventListener('focus', function() { if (this.value.length >= 1 && !state.user) { showSearchLoadingIn($('mb-search-dropdown')); doSearch(this.value.trim().replace('@', '')).then(r => renderSearchResults(r, $('mb-search-dropdown'), selectUser)); } });
  }
  if (usernameInput && !HAS_SEARCH) {
    usernameInput.addEventListener('input', function() {
      const clear = $('mb-clear-btn');
      if (this.value.trim().length > 0) { if (clear) clear.classList.add('visible'); }
      else { if (clear) clear.classList.remove('visible'); }
    });
  }
  $('mb-clear-btn')?.addEventListener('click', () => {
    if (HAS_SEARCH) { clearUser(); }
    else { const input = $('mb-username'), clear = $('mb-clear-btn'); if (input) { input.value = ''; input.focus(); } if (clear) clear.classList.remove('visible'); }
  });
  document.addEventListener('click', e => { const dd = $('mb-search-dropdown'), inp = $('mb-username'); if (dd && inp && !dd.contains(e.target) && e.target !== inp) dd.classList.remove('visible'); });
  $('mb-guide-link')?.addEventListener('click', function() { this.classList.toggle('open'); $('mb-guide-panel')?.classList.toggle('open'); });
  // ==================== V59.3: POPUP USERNAME EVENTS ====================
  if (HAS_SEARCH) {
    let popupSearchTimeout = null;
    const popupInput = $('mb-popup-username');
    const popupDropdown = $('mb-popup-search-dropdown');
    if (popupInput) {
      popupInput.addEventListener('input', function() {
        const q = this.value.trim().replace('@', '');
        if (popupUser && q !== popupUser.username) popupClearUser();
        if (popupSearchTimeout) clearTimeout(popupSearchTimeout);
        if (q.length < 1) { popupDropdown?.classList.remove('visible'); return; }
        showSearchLoadingIn(popupDropdown);
        popupSearchTimeout = setTimeout(async () => { const results = await doSearch(q); if (popupInput.value.trim().replace('@', '') === q) renderSearchResults(results, popupDropdown, popupSelectUser); }, 150);
      });
      popupInput.addEventListener('focus', function() { if (this.value.length >= 1 && !popupUser) { showSearchLoadingIn(popupDropdown); doSearch(this.value.trim().replace('@', '')).then(r => renderSearchResults(r, popupDropdown, popupSelectUser)); } });
    }
    $('mb-popup-clear-btn')?.addEventListener('click', popupClearUser);
    // Close dropdown on outside click inside popup
    document.addEventListener('click', e => { if (popupDropdown && popupInput && !popupDropdown.contains(e.target) && e.target !== popupInput) popupDropdown.classList.remove('visible'); });
    // Close popup
    $('mb-userpopup-close')?.addEventListener('click', closeUserPopup);
    $('mb-userpopup')?.addEventListener('click', function(e) { if (e.target === this) closeUserPopup(); });
    // Guide toggle in popup
    $('mb-popup-guide-link')?.addEventListener('click', function() { this.classList.toggle('open'); $('mb-popup-guide-panel')?.classList.toggle('open'); });
    // Confirm buttons in popup
    $('mb-userpopup-confirm-buy')?.addEventListener('click', () => {
      if (!popupUser) return;
      addToCart(true, popupUser);
    });
    $('mb-userpopup-confirm-cart')?.addEventListener('click', () => {
      if (!popupUser) return;
      addToCart(false, popupUser);
    });
  }
  // ==================== BUY / ADD TO CART ====================
  $('mb-buy-now')?.addEventListener('click', () => addToCart(true));
  $('mb-add-to-cart')?.addEventListener('click', () => addToCart(false));
}
// ==================== SOLD OUT UI ====================
function applySoldOutUI() {
  var loc = (CONFIG.LOCALE || 'fr').toLowerCase().split('-')[0];
  var SOLD_OUT_LABELS = {
    fr: ['Rupture de stock',   'Ce produit sera bientôt de retour 🔜'],
    en: ['Sold Out',           'This product will be back soon 🔜'],
    de: ['Ausverkauft',        'Dieses Produkt ist bald wieder verfügbar 🔜'],
    es: ['Agotado',            'Este producto volverá pronto 🔜'],
    it: ['Esaurito',           'Questo prodotto tornerà presto 🔜'],
    pt: ['Esgotado',           'Este produto estará de volta em breve 🔜'],
    nl: ['Uitverkocht',        'Dit product is binnenkort terug 🔜'],
    tr: ['Tükendi',            'Bu ürün yakında geri gelecek 🔜'],
    pl: ['Wyprzedany',         'Ten produkt wróci wkrótce 🔜'],
    ar: ['نفد المخزون',        'سيعود هذا المنتج قريبًا 🔜'],
    ja: ['在庫切れ',            'もうすぐ入荷します 🔜'],
    zh: ['缺货',               '该产品即将回归 🔜'],
    ko: ['품절',               '곧 다시 돌아옵니다 🔜'],
    sv: ['Slutsålt',           'Produkten är snart tillbaka 🔜'],
    da: ['Udsolgt',            'Dette produkt er snart tilbage 🔜'],
    no: ['Utsolgt',            'Dette produktet er snart tilbake 🔜'],
    nb: ['Utsolgt',            'Dette produktet er snart tilbake 🔜'],
    fi: ['Loppuunmyyty',       'Tuote palaa pian 🔜'],
    ro: ['Epuizat',            'Produsul va reveni în curând 🔜'],
    cs: ['Vyprodáno',          'Produkt se brzy vrátí 🔜'],
    el: ['Εξαντλήθηκε',        'Το προϊόν επιστρέφει σύντομα 🔜'],
  };
  var pair = SOLD_OUT_LABELS[loc] || SOLD_OUT_LABELS['en'];
  var label    = pair[0];
  var subLabel = pair[1];

  // V63: enforce sold-out on BOTH the live widget (#mb-selector) AND the Shoplift A/B copy
  // (#mb-selector-b) — the B copy has no availability data of its own. Idempotent + re-applied
  // to defeat any late client render, so out-of-stock products can never be sold from either one.
  var BUY_SEL = '.mb-buy-now, [id="mb-buy-now"]';
  var BTN_SEL = '.mb-buy-now, [id="mb-buy-now"], .mb-add-to-cart, [id="mb-add-to-cart"]';
  function mbEnforceSoldOut() {
    // 1. Banner above each buy button (once per widget)
    document.querySelectorAll(BUY_SEL).forEach(function(btn) {
      var host = btn.parentNode; if (!host || host.querySelector('.mb-soldout-banner')) return;
      var banner = document.createElement('div');
      banner.className = 'mb-soldout-banner';
      banner.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;background:#1a1a1a;border:2px solid #333;border-radius:14px;padding:16px 20px;margin:12px 0;text-align:center;font-family:-apple-system,BlinkMacSystemFont,sans-serif';
      banner.innerHTML = '<span style="font-size:17px;font-weight:800;color:#fff;letter-spacing:.3px">🚫 ' + label + '</span><span style="font-size:13px;color:#888;margin-top:2px">' + subLabel + '</span>';
      host.insertBefore(banner, btn);
    });
    // 2. Disable buy/cart buttons (both widgets) + relabel "Rupture de stock"
    document.querySelectorAll(BTN_SEL).forEach(function(btn) {
      btn.disabled = true;
      btn.style.opacity = '0.3';
      btn.style.cursor = 'not-allowed';
      btn.style.pointerEvents = 'none';
      var cur = btn.querySelector('#mb-buy-current') || btn.querySelector('.mb-buy-now-current');
      if (cur) cur.textContent = label;
      var suf = btn.querySelector('#mb-buy-suffix');
      if (suf) suf.textContent = '';
      var old = btn.querySelector('#mb-buy-old') || btn.querySelector('.mb-buy-now-old');
      if (old) old.style.display = 'none';
    });
    // 3. Qty pills struck-through + greyed (both widgets)
    document.querySelectorAll('.mb-qty-pill').forEach(function(pill) {
      pill.style.opacity = '0.35';
      pill.style.pointerEvents = 'none';
      pill.style.textDecoration = 'line-through';
      pill.classList.remove('selected');
    });
    // 4. Hide promos (both widgets)
    document.querySelectorAll('.mb-promo-btn, .mb-promos-wrap').forEach(function(el) { el.style.display = 'none'; });
  }
  mbEnforceSoldOut();
  setTimeout(mbEnforceSoldOut, 300);
  setTimeout(mbEnforceSoldOut, 1200);

  // 5. Intercept any click on EITHER selector (capture phase) so nothing can be added to cart
  ['mb-selector', 'mb-selector-b'].forEach(function(sid) {
    var wrap = document.getElementById(sid);
    if (!wrap || wrap.dataset.mbSoldoutBound) return;
    wrap.dataset.mbSoldoutBound = '1';
    wrap.addEventListener('click', function(e) {
      if (e.target.closest('.mb-qty-pill, .mb-buy-now, .mb-add-to-cart, [id="mb-buy-now"], [id="mb-add-to-cart"]')) {
        e.preventDefault(); e.stopImmediatePropagation();
      }
    }, true);
  });
}

// ==================== CURRENCY SYNC (header picker) ====================
// When user changes currency via the header selector, update CONFIG + reprice.
(function() {
  function syncCurrency(newCurr) {
    if (!newCurr || newCurr === CONFIG.CURRENCY) return;
    CONFIG.CURRENCY = newCurr;
    // Try to grab updated Shopify rate (set by Minimog/theme currency JS)
    try {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      if (!isNaN(r) && r > 0) CONFIG.RATE = r;
    } catch (e) {}
    if (!ALL_SOLD_OUT) updatePrices();
  }
  // Listen on MyBoost header currency selects (desktop + drawer)
  function attachCurrencySelect(id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('change', function() {
      setTimeout(function() { syncCurrency(el.value); }, 40);
    });
  }
  attachCurrencySelect('mbh-header-currency');
  attachCurrencySelect('mbh-drawer-currency');
  // Also catch any global event dispatched by theme currency converters
  document.addEventListener('currency:changed', function(e) {
    var c = e.detail && (e.detail.currency || e.detail.to || e.detail.newCurrency);
    if (c) syncCurrency(c);
  });
})();

// ==================== INIT ====================
function init() {
  // V63: data-rate comes from Liquid `cart.currency.rate`, which is unavailable (always 1) so non-EUR
  // markets showed raw EUR numbers (e.g. "20 AED"). Adopt Shopify's live currency+rate pair (the same
  // source the checkout gate uses) so formatMoney converts correctly in every market.
  try {
    var _sc = window.Shopify && window.Shopify.currency;
    if (_sc) {
      var _r = parseFloat(_sc.rate);
      // Only trust the rate when Shopify's active currency matches what we display (avoid switching currency)
      if (_r > 0 && (!_sc.active || _sc.active === CONFIG.CURRENCY)) CONFIG.RATE = _r;
    }
  } catch (e) {}
  applyTranslations();
  buildCountryList();
  const firstPill = document.querySelector('.mb-qty-pill.selected');
  if (firstPill) state.option1 = firstPill.dataset.value;
  if (HAS_SEARCH) {
    const saved = getCookie(CONFIG.COOKIE_NAME + '_' + INPUT_MODE);
    if (saved) try { const u = JSON.parse(saved); if (u?.username) selectUser(u); } catch {}
  }
  bindEvents();
  updatePrices();
  if (ALL_SOLD_OUT) applySoldOutUI();
  console.log('MyBoost V59.3 | ' + CONFIG.LOCALE + ' | ' + VARIANTS.length + ' variants | Mode: ' + INPUT_MODE + (ALL_SOLD_OUT ? ' | SOLD OUT' : ''));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();


/* V60: ensure summary box is in sync after initial render and on any state change */
(function() {
  function v60SyncSummary() {
    if (typeof window.__v60_updateSubSummary === 'function') {
      try { window.__v60_updateSubSummary(); } catch (e) {}
    }
  }
  if (document.readyState !== 'loading') {
    setTimeout(v60SyncSummary, 200);
    setTimeout(v60SyncSummary, 600);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(v60SyncSummary, 200);
      setTimeout(v60SyncSummary, 600);
    });
  }
  /* Re-sync after variant/quantity pill clicks (mutates price) */
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mb-qty-pill') || e.target.closest('.mb-nat-type')) {
      setTimeout(v60SyncSummary, 50);
      setTimeout(v60SyncSummary, 250);
    }
  });
})();


/* V62: update price suffix on buttons + renewal note + algo discount tag based on delivery state */
(function() {
  function v62Sync() {
    if (typeof state === 'undefined') return;
    var I18N_TMP = (function(){ try { return JSON.parse(document.getElementById('mb-i18n').textContent); } catch(e) { return {}; } })();
    function tx(k) { return I18N_TMP[k] || ''; }
    var current = document.getElementById('mb-buy-current')?.textContent?.trim() || '';
    var suffix = '';
    var isSub = (state.delivery === 'monthly' || state.delivery === 'weekly' || state.delivery === 'progressive');
    if (state.delivery === 'monthly') suffix = tx('suffix_monthly') || '/mois';
    else if (state.delivery === 'weekly') suffix = tx('suffix_weekly') || '/sem';
    else suffix = '';

    var buyS = document.getElementById('mb-buy-suffix');
    if (buyS) buyS.textContent = suffix;
    var cartS = document.getElementById('mb-add-cart-suffix');
    if (cartS) cartS.textContent = current ? (current + ' ' + suffix).trim() : '';
    // V62-FIX: do NOT overwrite renewal text (rendered server-side via Liquid).
    // Just toggle visibility on the wrapper based on subscription state.
    var noteWrap = document.getElementById('mb-renewal-note');
    if (noteWrap) noteWrap.style.display = isSub ? '' : 'none';
  }
  function v62Init() {
    setTimeout(v62Sync, 250);
    setTimeout(v62Sync, 700);
    document.addEventListener('click', function(e) {
      if (e.target.closest('.mb-qty-pill') || e.target.closest('.mb-nat-type') ||
          e.target.closest('.mb-freq-btn') || e.target.closest('.mb-delivery-card')) {
        setTimeout(v62Sync, 60);
        setTimeout(v62Sync, 250);
      }
    });
  }
  if (document.readyState !== 'loading') v62Init();
  else document.addEventListener('DOMContentLoaded', v62Init);
  window.__v62_sync = v62Sync;
})();


/* V62: rotate Trustpilot reviews every 5 seconds */
(function() {
  function rotateTpReviews() {
    var rvs = document.querySelectorAll('#mb-tp-reviews .mb-tp-rv');
    if (rvs.length < 2) return;
    var idx = 0;
    setInterval(function() {
      rvs[idx].classList.remove('mb-tp-rv--active');
      idx = (idx + 1) % rvs.length;
      rvs[idx].classList.add('mb-tp-rv--active');
    }, 5500);
  }
  if (document.readyState !== 'loading') setTimeout(rotateTpReviews, 1000);
  else document.addEventListener('DOMContentLoaded', function() { setTimeout(rotateTpReviews, 1000); });
})();


/* V64: "En une fois" ne masquait pas la mention d'achat récurrent dans la copie Shoplift B.
   Cause: #mb-card-immediate est dupliqué dans #mb-selector (A, V61) et #mb-selector-b (B, V60).
   getElementById bind le handler inline de B sur la card de A, donc la card "En une fois" de B
   n'avait aucun handler -> clic sans effet -> .mb-subscription-notice (qui n'existe que dans B)
   restait affiché. On gère ici la sélection + le notice PAR widget, via délégation, sans dépendre
   des IDs dupliqués. Inoffensif pour A (A n'a pas de .mb-subscription-notice). */
(function() {
  function isImmediate(card) {
    return !!card && (card.id === 'mb-card-immediate' || /\b(?:immediate|onetime)\b/.test(card.className) || card.getAttribute('data-type') === 'onetime');
  }
  function syncNotice(widget) {
    if (!widget) return;
    var sel = widget.querySelector('.mb-delivery-card.selected');
    var hide = isImmediate(sel);
    widget.querySelectorAll('.mb-subscription-notice').forEach(function(n) { n.style.display = hide ? 'none' : ''; });
    /* V65: masquer aussi la mention recurrente du widget produit A (#mb-renewal-note / .mb-renewal-note).
       Bug: en "une fois" la note "achat recurrent ou differe" restait affichee. Double cause :
       (1) son seul toggle (v62Sync) teste `if (typeof state === 'undefined') return` mais `state` est un
           `let` declare dans une AUTRE IIFE -> hors de portee -> early-return permanent, jamais execute ;
       (2) son CSS est `display:flex !important` -> un `style.display='none'` inline est ignore.
       On la pilote donc ici, au DOM, par widget, et on FORCE via setProperty(...,'important').
       Masquee en "une fois", visible en abonnement. No-op pour B (pas de .mb-renewal-note). */
    widget.querySelectorAll('.mb-renewal-note').forEach(function(n) { n.style.setProperty('display', hide ? 'none' : 'flex', 'important'); });
  }
  function syncAll() { document.querySelectorAll('.mb-selector').forEach(syncNotice); }
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.mb-delivery-card');
    if (card) {
      var widget = card.closest('.mb-selector');
      if (widget) {
        // Reflète la sélection dans le DOM de CE widget (le handler "immediate" de B est mort à cause des IDs dupliqués)
        widget.querySelectorAll('.mb-delivery-card').forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        syncNotice(widget);
      }
      return;
    }
    // Un changement de quantité/nationalité peut redéclencher d'autres sync -> on ré-affirme le notice depuis le DOM
    if (e.target.closest('.mb-qty-pill') || e.target.closest('.mb-nat-type')) {
      setTimeout(syncAll, 60);
      setTimeout(syncAll, 300);
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { setTimeout(syncAll, 250); setTimeout(syncAll, 700); });
  else { setTimeout(syncAll, 250); setTimeout(syncAll, 700); }
  window.__mbSyncSubNotices = syncAll;
})();



/* ============================================================================
   COMPLIANCE (2026-07): recurring-purchase consent gate.
   Per-widget & DOM-driven (like the V64/V65 notice sync) so it works with the
   A/B-duplicated DOM and every .mb-selector variant on the page. It:
     1. shows the recurring terms + amount in plain language ABOVE the buy button
        (only when a recurring plan is selected), and
     2. BLOCKS Buy / Add-to-cart until the customer actively ticks the consent box.
   Guarded by window.__mbConsentInit so multiple copies on one page are harmless.
   ========================================================================== */
(function(){
  if (window.__mbConsentInit) return; window.__mbConsentInit = true;

  function injectCss(){
    if (document.getElementById('mb-consent-css')) return;
    var s = document.createElement('style'); s.id = 'mb-consent-css';
    s.textContent =
      '.mb-consent{display:flex;flex-direction:column;gap:10px;padding:13px 15px;margin:0 0 11px;border:1.5px solid #e2c6f0;background:#fbf6ff;border-radius:12px}' +
      '.mb-consent--error{border-color:#e2467a;background:#fff2f6}' +
      '.mb-consent-terms{display:flex;gap:8px;align-items:flex-start;font-size:14px;line-height:1.5;color:#3a2b46;font-weight:600;text-align:left}' +
      '.mb-consent-terms-icon{flex:0 0 auto;font-size:15px;line-height:1.2}' +
      '.mb-consent-terms-text strong{font-weight:800}' +
      '.mb-consent-check{position:relative;display:flex;gap:10px;align-items:flex-start;cursor:pointer;font-size:13.5px;line-height:1.45;color:#3a2b46;font-weight:600;text-align:left}' +
      '.mb-consent-check input{position:absolute;opacity:0;width:0;height:0}' +
      '.mb-consent-box{flex:0 0 auto;width:20px;height:20px;border:2px solid #b9a7c6;border-radius:6px;background:#fff;display:flex;align-items:center;justify-content:center;transition:all .15s}' +
      '.mb-consent-box svg{width:13px;height:13px;stroke:#fff;stroke-width:3.2;fill:none;opacity:0;transition:opacity .15s}' +
      '.mb-consent-check input:checked ~ .mb-consent-box{background:#8b3fd6;border-color:#8b3fd6}' +
      '.mb-consent-check input:checked ~ .mb-consent-box svg{opacity:1}' +
      '.mb-consent-check input:focus-visible ~ .mb-consent-box{box-shadow:0 0 0 3px rgba(139,63,214,.35)}' +
      '.mb-consent--error .mb-consent-box{border-color:#e2467a}' +
      '.mb-consent--error .mb-consent-terms{color:#c02458}' +
      '@keyframes mbConsentShake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}30%,50%,70%{transform:translateX(-4px)}40%,60%{transform:translateX(4px)}}' +
      '.mb-consent--shake{animation:mbConsentShake .5s cubic-bezier(.36,.07,.19,.97)}' +
      '.mb-delivery-badge--sub{background:#8b3fd6!important;color:#fff!important}' +
      '.mb-consent-agree{margin:0;font-size:12.5px;line-height:1.5;color:#6a6a75;text-align:left}';
    document.head.appendChild(s);
  }

  function i18n(){ try { return JSON.parse(document.getElementById('mb-i18n').textContent); } catch(e){ return {}; } }
  function isRecurring(card){
    if (!card) return false;
    if (card.id === 'mb-card-immediate') return false;
    if (/\b(?:immediate|onetime)\b/.test(card.className)) return false;
    if (card.getAttribute && card.getAttribute('data-type') === 'onetime') return false;
    return true;
  }
  function freqOf(widget, card){
    var dt = card && card.getAttribute && card.getAttribute('data-type');
    if (dt === 'monthly') return 'monthly';
    if (dt === 'weekly') return 'weekly';
    var mo = widget.querySelector('#mb-freq-monthly, .mb-freq-btn[data-freq="monthly"]');
    if (mo && mo.classList.contains('selected')) return 'monthly';
    return 'weekly';
  }
  function priceOf(widget){
    var el = widget.querySelector('.mb-buy-now-current, #mb-buy-current');
    return (el && el.textContent.trim()) || '';
  }
  function syncOne(widget){
    var box = widget.querySelector('.mb-consent'); if (!box) return;
    var sel = widget.querySelector('.mb-delivery-card.selected');
    var rec = isRecurring(sel);
    box.style.display = rec ? '' : 'none';
    if (!rec){ box.classList.remove('mb-consent--error'); return; }
    var T = i18n();
    var tmpl = T['consent_terms_' + freqOf(widget, sel)] || T['consent_terms_weekly'] || '';
    var tEl = box.querySelector('.mb-consent-terms-text');
    if (tEl) tEl.innerHTML = tmpl.replace('__price__', '<strong>' + (priceOf(widget) || '') + '</strong>');
  }
  function syncAll(){ document.querySelectorAll('.mb-selector').forEach(syncOne); }
  window.__mbSyncConsent = syncAll;

  function toast(msg){
    var ex = document.getElementById('mb-consent-toast'); if (ex) ex.remove();
    var el = document.createElement('div'); el.id = 'mb-consent-toast';
    el.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:100000;background:#c02458;color:#fff;padding:13px 20px;border-radius:14px;font-size:14px;font-weight:600;box-shadow:0 8px 30px rgba(0,0,0,.3);max-width:92vw;text-align:center;line-height:1.35';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function(){ el.style.transition='opacity .3s'; el.style.opacity='0'; setTimeout(function(){ if(el.parentNode) el.remove(); }, 300); }, 3800);
  }

  /* Gate — capture phase so it runs BEFORE the button's own click handler (addToCart). */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.mb-buy-now, .mb-add-to-cart'); if (!btn) return;
    var widget = btn.closest('.mb-selector'); if (!widget) return;
    var sel = widget.querySelector('.mb-delivery-card.selected');
    if (!isRecurring(sel)) return;
    var cb = widget.querySelector('.mb-consent-checkbox');
    if (cb && !cb.checked){
      e.preventDefault(); e.stopImmediatePropagation();
      var box = widget.querySelector('.mb-consent');
      if (box){
        box.classList.add('mb-consent--error'); box.classList.add('mb-consent--shake');
        try { box.scrollIntoView({block:'center',behavior:'smooth'}); } catch(_e){}
        setTimeout(function(){ box.classList.remove('mb-consent--shake'); }, 560);
      }
      var T = i18n();
      toast(T['consent_required'] || 'Please tick the box to agree to the recurring charges before continuing.');
    }
  }, true);

  document.addEventListener('change', function(e){
    var cb = e.target.closest && e.target.closest('.mb-consent-checkbox'); if (!cb) return;
    var widget = cb.closest('.mb-selector');
    var box = widget ? widget.querySelector('.mb-consent') : null;
    if (box && cb.checked) box.classList.remove('mb-consent--error');
  });

  document.addEventListener('click', function(e){
    if (e.target.closest('.mb-delivery-card') || e.target.closest('.mb-freq-btn') ||
        e.target.closest('.mb-qty-pill') || e.target.closest('.mb-nat-type') || e.target.closest('.mb-promo-btn')){
      setTimeout(syncAll, 60); setTimeout(syncAll, 300);
    }
  }, true);

  function boot(){ injectCss(); setTimeout(syncAll, 200); setTimeout(syncAll, 650); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
